import { Form, useActionData } from "@remix-run/react";
import { useEffect, useState } from "react";
import { useRemixForm } from "remix-hook-form";
import type { action } from "../detay+/$id";
import { type hizmetFormFormSchemaType, hizmetFormResolver } from "../detay+/features/contact.schemas";

const ContactForm = ({ services }: { services: any[] }) => {
  const [result, setResult] = useState<string>('')
  const actionData = useActionData<typeof action>()

  const { register, handleSubmit, reset, formState: { errors } } = useRemixForm<hizmetFormFormSchemaType>({
    mode: 'onSubmit',
    resolver: hizmetFormResolver,
    defaultValues: {
      hizmetler: '',
    },
  })

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    console.log('actionData', actionData)
    if (actionData?.success) {
      setResult('Mesajınız gönderildi')
      reset()
    } else if (actionData && actionData?.success === false) {
      setResult('Mesajınız gönderilemedi. Lütfen daha sonra tekrar deneyiniz.')
    }
  }, [actionData])
  return (
    <div className="w-full mx-auto py-20">
      <small className="flex w-60 mx-auto my-12 border-b-2 border-gray-200 text-[16px] font-bold before:content-[''] before:absolute before:-top-2 before:left-0 before:right-0 before:m-auto  before:w-5 before:rounded-full before:h-5 before:bg-[#16437c] relative" />
      <h1 className="text-2xl font-bold text-[#444444] text-center font-raleway mb-4">HİZMETLERİMİZ İÇİN <b className="font-bold text-[#20b1d7]">BİZE ULAŞIN!</b></h1>
      <p className="text-center mb-8 text-[#555555] font-lato">
        Teklif almak ve hizmetlerimiz ile alakalı bilgi almak için teklif formumuzu doldurarak bize ulaşabilirsiniz.
      </p>
      <span className="w-full relative flex text-[#444444] font-raleway text-[24px] font-bold py-2 mb-8 after:absolute after:top-4 after:right-0 after:content-[''] after:h-1.5 after:border-dotted after:border-t-2 after:border-b-2 after:border-gray-300 after:w-[70%] after:mx-auto before:content-[''] before:absolute before:top-6 before:right-0 before:h-1.5 before:border-dotted before:border-t-2 before:border-b-2 before:border-gray-300 before:w-[70%] before:mx-auto">Bize bir e-posta gönderin</span>
      <Form className="flex flex-wrap gap-4 w-full [&_label]:font-raleway [&_label]:text-[13px] [&_label]:font-bold [&_label]:text-[#444444]" onSubmit={handleSubmit} method="POST">
        <div className="mb-4 w-full md:w-[calc(33.33%-10px)]">
          <label className="block text-sm font-medium mb-1" htmlFor="name">Firma *</label>
          <input
            type="text"
            id="name"
            className="w-full p-2 border border-gray-300"
            {...register('firmaAdi')}
          />
          {errors.firmaAdi && <p className="text-red-500">{errors.firmaAdi.message}</p>}
        </div>
        <div className="mb-4 w-full md:w-[calc(33.33%-10px)]">
          <label className="block text-sm font-medium mb-1" htmlFor="name">YETKİLİ *</label>
          <input
            type="text"
            id="name"
            className="w-full p-2 border border-gray-300"
            {...register('adSoyad')}
          />
          {errors.adSoyad && <p className="text-red-500">{errors.adSoyad.message}</p>}
        </div>
        <div className="mb-4 w-full md:w-[calc(33.33%-14px)]">
          <label className="block text-sm font-medium mb-1" htmlFor="email">E-MAİL *</label>
          <input
            type="email"
            id="email"
            className="w-full p-2 border border-gray-300"
            {...register('email')}
          />
          {errors.email && <p className="text-red-500">{errors.email.message}</p>}
        </div>
        <div className="mb-4 w-full md:w-[calc(33.33%-14px)]">
          <label className="block text-sm font-medium mb-1" htmlFor="phone">TELEFON</label>
          <input
            type="tel"
            id="phone"
            className="w-full p-2 border border-gray-300"
            {...register('telefon')}
          />
          {errors.telefon && <p className="text-red-500">{errors.telefon.message}</p>}
        </div>
        <div className="mb-4 w-full md:w-[calc(33.33%-14px)]">
          <label className="block text-sm font-medium mb-1" htmlFor="subject">KONU</label>
          <input
            type="text"
            id="subject"
            className="w-full p-2 border border-gray-300"
            {...register('konu')}
          />
          {errors.konu && <p className="text-red-500">{errors.konu.message}</p>}
        </div>
        <div className="mb-4 w-full md:w-[calc(33.33%-14px)]">
          <label className="block text-sm font-medium mb-1" htmlFor="services">HİZMETLER</label>
          <select
            id="services"
            className="w-full p-2 border border-gray-300"
            {...register('hizmetler')}
          >
            <option value="">- Hizmet Seçiniz -</option>
            {services.map((service) => (
              <option key={service.title} value={service.title}>{service.title}</option>
            ))}
          </select>
          {errors.hizmetler && <p className="text-red-500">{errors.hizmetler.message}</p>}
        </div>
        <div className="mb-4 w-full">
          <label className="block text-sm font-medium mb-1" htmlFor="message">MESAJINIZ *</label>
          <textarea
            id="message"
            className="w-full p-2 border border-gray-300"
            rows={4}
            {...register('mesaj')}
          />
          {errors.mesaj && <p className="text-red-500">{errors.mesaj.message}</p>}
        </div>
        {result && <p className="text-green-500">{result}</p>}
        <button
          type="submit"
          className=" bg-[#16437c] font-raleway cursor-pointer text-[18px] text-white font-bold py-2 rounded hover:bg-[#20b1d7] px-4"
        >
          Mesaj Gönder
        </button>
      </Form>
    </div>
  );
};

export default ContactForm;